var DISCUSS_DOM = {
    // 重置论盘页的样式
    updateDiscussPageStyle() {
        var pageDiv = document.getElementsByClassName('discuss-page')[0];
        if(pageDiv) {
            // pageDiv.style.position = 'fixed';
            pageDiv.style.width = innerWidth + 'px';
            pageDiv.style.height = innerHeight + 'px';
            pageDiv.style.overflow = 'hidden';
        }
    },
    // 重置论盘页聊天记录列表的样式
    updateDiscussFormStyle(){
        var topbarDiv = document.getElementsByClassName('discuss-fate-topbar')[0],
            listDiv = document.getElementsByClassName('discuss-history-list')[0],
            titleDiv = document.getElementsByClassName('discuss-title')[0],
            bottomDiv = document.getElementsByClassName('discuss-bottom-bar-box')[0];
        var style = '', height = 0;
        setTimeout(() => {
            height = topbarDiv ? height+=topbarDiv.clientHeight : height;
            height = titleDiv ? height+=titleDiv.clientHeight : height;
            style = 'padding-top:'+height+'px; ';
            height = bottomDiv ? height+=bottomDiv.clientHeight : height;
            style = bottomDiv ? style+'padding-bottom:'+ bottomDiv.clientHeight+'px; ' : style;
            style = style+'height: '+height+'px'; 
            if(listDiv) {
                listDiv.style = style;
            }
        
            // var discussListDiv = document.getElementById('DiscussList');
            // if(discussListDiv) {
            //     // discussListDiv.style.height = (innerHeight - height) + 'px';
            //     discussListDiv.style.height = innerHeight + 'px';
            // }
        }, 0);
    },
    // 输入框聚焦之后重置样式:将顶部迷你命盘定住
    updateDiscussFormScrollStyle() {
        var topDiv = document.getElementsByClassName('comment-title-bar')[0];
        if(topDiv) {
            topDiv.style.display = 'none';
        }
        
        var bottomDiv = document.getElementsByClassName('discuss-bottom-bar-box')[0];
        if(bottomDiv) {
            bottomDiv.style = 'position: absolute; left: 0; bottom: 0;';
        }
    },
    resetDiscussFormScrollStyle() {
        var topDiv = document.getElementsByClassName('comment-title-bar')[0];
        if(topDiv){
            topDiv.style.display = '';
        }
        var bottomDiv = document.getElementsByClassName('discuss-bottom-bar-box')[0];
        if(bottomDiv) {
            bottomDiv.style = '';
        }
    },
    // 更新聊天信息:滚动至最新
    updateDiscussHistoryListScrollStyle() {
        setTimeout(() => {
            var listNode = document.getElementById('DiscussList');
            if(listNode && typeof(listNode.scrollTo) == 'function') {
                listNode.scrollTo(0, listNode.firstElementChild.clientHeight + 200);
            }
        }, 0);
    }

}

export {
    DISCUSS_DOM
}